<template>
  <div class="service-visits-calendar-controls">
    <v-btn
      small
      class="service-visits-calendar-controls__navigation-button"
      aria-label="Предишен месец"
      @click="$emit('previous')"
    >
      <v-icon small>mdi-chevron-left</v-icon>
    </v-btn>
    <v-select
      :value="selectedMonthNumber"
      :items="monthOptions"
      item-text="label"
      item-value="value"
      dense
      outlined
      hide-details
      class="service-visits-calendar-controls__month"
      @input="$emit('update-month', $event)"
    ></v-select>
    <v-select
      :value="selectedYear"
      :items="yearOptions"
      dense
      outlined
      hide-details
      class="service-visits-calendar-controls__year"
      @input="$emit('update-year', $event)"
    ></v-select>
    <v-btn
      small
      class="service-visits-calendar-controls__navigation-button"
      aria-label="Следващ месец"
      @click="$emit('next')"
    >
      <v-icon small>mdi-chevron-right</v-icon>
    </v-btn>
    <span class="service-visits-calendar-controls__selected-period">
      {{ selectedMonthLabel }}
    </span>
  </div>
</template>

<script>
export default {
  name: "ServiceVisitsCalendarControls",
  props: {
    selectedMonthNumber: {
      type: Number,
      required: true
    },
    selectedYear: {
      type: Number,
      required: true
    },
    monthOptions: {
      type: Array,
      required: true
    },
    yearOptions: {
      type: Array,
      required: true
    },
    selectedMonthLabel: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.service-visits-calendar-controls {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
}

.service-visits-calendar-controls__navigation-button {
  background-color: #e1f0ff !important;
  color: #3699ff !important;
  min-width: 2.5rem !important;
}

.service-visits-calendar-controls__month {
  max-width: 190px;
}

.service-visits-calendar-controls__year {
  max-width: 120px;
}

.service-visits-calendar-controls__selected-period {
  font-weight: 600;
  margin-left: auto;
}

@media (max-width: 767.98px) {
  .service-visits-calendar-controls {
    display: grid;
    gap: 0.5rem;
    grid-template-columns: 2.5rem minmax(0, 1fr) minmax(5.5rem, 0.55fr) 2.5rem;
    margin-bottom: 1rem;
  }

  .service-visits-calendar-controls__month,
  .service-visits-calendar-controls__year {
    max-width: none;
    min-width: 0;
    width: 100%;
  }

  .service-visits-calendar-controls__selected-period {
    display: none;
  }
}

@media (max-width: 575.98px) {
  .service-visits-calendar-controls {
    grid-template-columns: minmax(0, 1fr) minmax(6.5rem, 0.65fr);
  }

  .service-visits-calendar-controls__navigation-button {
    display: none;
  }
}
</style>
